import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Card from "@/components/Card/index";
import ContentHeader from "@/components/ContentHeader";
import InfinityScrollList from "@/components/InfinityScrollList";
import Loading from "@/components/Loading";
import { useColumsInRow, useCopyrights, usePagination, useIntersectionObserver } from "@/hooks";
import styles from "@/styles/Grid.module.scss";
import chunk from "lodash/chunk";
import { memo, cloneElement, createElement, useEffect, useMemo, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Grid(_ref) {
  var _items$data;
  let {
    header,
    itemComponent = Card,
    // itemをレンダーするコンポーネント
    limit,
    maxLength,
    loadMore,
    loading,
    // useQueryの戻り値
    error,
    // useQueryの戻り値
    fetchMore,
    // useQueryの戻り値
    items,
    noContent,
    viewTypeClassName
  } = _ref;
  if (error) {
    // TODO: error view
  }
  const columsInRow = useColumsInRow();
  const {
    setCopyrights
  } = useCopyrights();
  const {
    enableLoadMore,
    fetchMoreCallback
  } = usePagination({
    limit,
    maxLength,
    loadMore,
    fetchMore,
    items
  });
  const dataLength = (items === null || items === void 0 || (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) || 0;
  const chunkedData = useMemo(() => {
    return chunk(items === null || items === void 0 ? void 0 : items.data, columsInRow);
  }, [dataLength, columsInRow, items]);
  useEffect(() => {
    if (items && items.data && items.data.length > 0) {
      const copyrights = items.data.map(item => item.copyright);
      setCopyrights(copyrights);
    }
  }, [dataLength]);
  if (!loading && chunkedData.length === 0 && columsInRow) {
    if (noContent) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.grid,
        children: /*#__PURE__*/cloneElement(noContent)
      });
    } else {
      return null;
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.grid,
    children: [header && /*#__PURE__*/_jsx(ContentHeader, _objectSpread({
      viewTypeClassName: viewTypeClassName
    }, header)), (loading && dataLength === 0 || !columsInRow) && /*#__PURE__*/_jsx(Loading, {
      showStart: 100
    }), /*#__PURE__*/_jsx(InfinityScrollList, {
      loadMore: enableLoadMore,
      fetchMore: fetchMoreCallback,
      children: chunkedData.map((data, i) => /*#__PURE__*/_jsx(GridRow, {
        row: i,
        rowData: data,
        itemComponent: itemComponent,
        columsInRow: columsInRow
      }, `grid-row-${i}`))
    })]
  });
}
const GridRow = /*#__PURE__*/memo(_ref2 => {
  let {
    rowData,
    row,
    itemComponent,
    columsInRow
  } = _ref2;
  const rowRef = useRef();
  const intersect = useIntersectionObserver(rowRef, {
    root: null,
    rootMargin: "100px",
    threshold: 0.0
  });
  return /*#__PURE__*/_jsx("div", {
    className: styles.row,
    ref: rowRef,
    children: rowData.map((data, i) => /*#__PURE__*/_jsx("div", {
      className: styles.item,
      style: {
        width: `${100 / columsInRow}%`
      },
      children: /*#__PURE__*/createElement(itemComponent, {
        item: data,
        intersect
      })
    }, `grid-row-item-${row}-${i}`))
  });
});